import { dataEnvelopeSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconEnvelopeSolid = /*#__PURE__*/createIcon(dataEnvelopeSolid)
export default IconEnvelopeSolid
